import upperFirst from 'lodash/upperFirst';
import { useAvailabilityFilter } from '../sideFiltersCategories/sideFiltersAvailabilityCategory/availability-filter.composable';
import { IProductFilterField } from '@dh-io-emh/shared/src/models/product-filter/product-filter-base.model';
import { computed } from 'vue';
import { getSelectedFilterCounter } from '../../composables/filter.composable';

export const useSideFiltersContent = (filterCategories, selectedFilters, emit?) => {
  const selectedFiltersCount = computed(() => getSelectedFilterCounter(selectedFilters.value));

  const isAnyFilterSelected = computed(() => selectedFiltersCount.value > 0);

  const { availabilityFilter, filteredSideFilters } = useAvailabilityFilter(filterCategories);

  const getCategoryComponentName = (categoryName) => `EmhSideFilters${upperFirst(categoryName || '')}Category`;

  const onChangeCategory = (categoryName: string) => emit('change-category', categoryName);

  const onChangeFilter = (filter: Partial<IProductFilterField>): void => {
    emit('change-filter', filter);
  };

  const onClearAllFilters = () => emit('clear-all-filters');

  const onClearCategory = (codes: string[]) => emit('clear-category', codes);

  return {
    onChangeCategory,
    onChangeFilter,
    onClearAllFilters,
    onClearCategory,
    getCategoryComponentName,
    filteredSideFilters,
    availabilityFilter,
    isAnyFilterSelected,
    selectedFiltersCount,
  };
};
